import * as React from 'react';

/*
 * Manage Job Comment
 *
 * Thin page wrapper for the /job_comments route. The comments view itself lives
 * in JobCommentsContent, which is shared with the slide-out Main Comment Modal
 * (JobCommentsModal). This route is kept as a fallback / deep-link target; the
 * JOB ACTIONS menu now opens the modal instead of navigating here.
 */
import { RouteComponentProps } from 'react-router-dom';
import JobCommentsContent from './JobCommentsContent';

const ManageJobComment: React.FC<RouteComponentProps<any>> = props => {
    return <JobCommentsContent variant="page" {...props} />;
};

export default ManageJobComment;
